import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuid, } from 'uuid';
import AsyncActionButton from '../button/AsyncActionButton';

class SearchBarWithCountryCodeDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.button = React.createRef();
    this.comboId = uuid();
    this.inputId = uuid();
    const {
      comboFields = [], defaultText = '', secondaryDropdownValues = [],
    } = props;
    const value = comboFields.length > 0 ? comboFields[0].value : '';
    const secondaryDropDownSelection = secondaryDropdownValues.length > 0 ? secondaryDropdownValues[0].value : '';
    this.state = {
      isLoading: false,
      comboBoxElement: this.buildComboBox(props),
      combo: {
        value,
        secondaryDropDownSelection,
      },
      search: {
        value: defaultText,
      },
    };
  }

  onLoadCompletion() {
    this.setState({
      isLoading: false,
    });
  }

  onReset() {
    const { comboFields = [], defaultText = '', secondaryDropdownValues = [], } = this.props;
    const value = comboFields.length > 0 ? comboFields[0].value : '';
    const secondaryDropDownSelection = secondaryDropdownValues.length > 0 ? secondaryDropdownValues[0].value : '';
    const { combo, search, } = this.state;
    this.setState({
      combo: {
        ...combo,
        value,
        secondaryDropDownSelection,
      },
      search: {
        ...search,
        value: defaultText,
      },
    });
  }

  onComboChange(event, props) {
    const { onComboChange, } = props;
    if (onComboChange) {
      onComboChange({ ...event, });
    }

    const mostRecentPrimaryDropDownSelection = event.currentTarget.value;
    this.setState(prevState => ({
      combo: {
        ...prevState.combo,
        value: mostRecentPrimaryDropDownSelection,
      },
    }), () => {
      this.setState({
        secondaryComboBoxElement: this.buildSecondaryComboBox(props),
      });
    });
  }

  onSecondaryComboChange(event, props) {
    const { onComboChange, } = props;
    if (onComboChange) {
      onComboChange({ ...event, });
    }

    const mostRecentSecondaryDropDownSelection = event.currentTarget.value;

    this.setState(
      prevState => ({
        combo: {
          ...prevState.combo,
          secondaryDropDownSelection: mostRecentSecondaryDropDownSelection,
        },
      })
    );
  }

  onInputTextChange(event, props) {
    const { onTextChange, } = props;
    if (onTextChange) {
      onTextChange({ ...event, });
    }

    this.setState({
      search: {
        value: event.currentTarget.value.trim(),
      },
    });
  }

  onKeyPress = (event, props) => {
    if (event.key === 'Enter') {
      this.onClick(event, props);
    }
  };

  onClick(event, props) {
    const { onClick, } = props;
    const { combo, search, } = this.state;

    const modifiedSearch = { ...search, };

    // if the primary drop down selection is a phone number, add a country code prefix to the user's input
    if (combo.value === 'phoneNumber') {
      const userInputWithCountryCode = combo.secondaryDropDownSelection + search.value;
      modifiedSearch.value = userInputWithCountryCode;
    }

    if (onClick) {
      this.beginLoading();
      onClick({
        event: {
          ...event,
        },
        combo: {
          ...combo,
        },
        search: modifiedSearch,
        kill: () => this.onLoadCompletion(),
        reset: () => this.onReset(),
      });
    }
  }

  beginLoading() {
    this.setState({
      isLoading: true,
    });
  }

  buildComboBox(props) {
    const { comboFields = [], } = props;
    if (comboFields.length === 0) {
      return null;
    }
    return (
      <select
        id={this.comboId}
        onChange={event => this.onComboChange(event, props)}
        className="form-select mt-2 me-2"
      >
        {comboFields.map(data => (
          <option key={uuid()} value={data.value}>
            {data.display}
          </option>
        ))}
      </select>
    );
  }

  buildSecondaryComboBox(props) {
    const { secondaryDropdownValues = [], } = props;
    const { combo, } = this.state;

    if (secondaryDropdownValues.length === 0 || combo.value !== 'phoneNumber') {
      return null;
    }

    return (
      <select
        id={this.comboId}
        onChange={event => this.onSecondaryComboChange(event, props)}
        className="form-select mt-2 me-2"
      >
        {secondaryDropdownValues.map(data => (
          <option key={uuid()} value={data.value}>
            {data.display}
          </option>
        ))}
      </select>
    );
  }

  clickConsumer(clickAction) {
    const { clickConsumer, } = this.props;
    if (clickConsumer) {
      clickConsumer(clickAction);
    }
  }

  render() {
    const { isLoading, comboBoxElement, secondaryComboBoxElement, } = this.state;
    const { hidden, defaultText = '', } = this.props;

    return (
      <div hidden={hidden}>
        <div className="inline-form-row">
          {comboBoxElement} {secondaryComboBoxElement}
          <input
            id={this.inputId}
            defaultValue={defaultText}
            className="form-control mt-2 me-2 col-lg-8 col-md-12 sm-12"
            type="search"
            placeholder="Search"
            aria-label="Search"
            onChange={event => this.onInputTextChange(event, this.props)}
            onKeyDown={event => this.onKeyPress(event, this.props)}
          />
          <AsyncActionButton
            isLoading={isLoading}
            loadingVariant="secondary"
            variant="success"
            contents="Search"
            className="mt-2"
            clickConsumer={func => this.clickConsumer(func)}
            onClick={event => this.onClick(event, this.props)}
          />
        </div>
      </div>
    );
  }
}

SearchBarWithCountryCodeDropdown.defaultProps = {
  comboFields: [],
  secondaryDropdownValues: [],
  hidden: false,
  defaultText: '',
  clickConsumer: null,
};

SearchBarWithCountryCodeDropdown.propTypes = {
  comboFields: PropTypes.array,
  secondaryDropdownValues: PropTypes.array,
  hidden: PropTypes.bool,
  defaultText: PropTypes.string,
  clickConsumer: PropTypes.func,
};

export default SearchBarWithCountryCodeDropdown;
